import {CLEAR_AVAILABILITY, SET_AVAILABILITY, SET_OBJECT_ID_BUSY, SET_OBJECTS, SET_ROOMS, SET_ROOM_ID} from "./constans";


let initialState = {

};


let newState = null;
const busyCalendarReducers = (state = initialState, action) => {

    switch (action.type) {
        case SET_OBJECTS: {
            return {...state, objects: action.payload}
        }
        case SET_OBJECT_ID_BUSY: {
            return {...state, objectId: action.payload}
        }
        case SET_ROOMS: {
            return {...state, rooms: action.payload}
        }
        case SET_ROOM_ID: {
            return {...state, room: action.payload}
        }
        case SET_AVAILABILITY: {
            return {...state, availability: action.payload}
        }
        case CLEAR_AVAILABILITY: {
            return {newState}
        }
        default:
            return state;
    }
};


export default busyCalendarReducers;